// gnb
export const PATH_NAME_HOME = 'home'
export const PATH_NAME_BROADCAST = 'broadcast'
export const PATH_NAME_LIVE = 'live'
export const PATH_NAME_MOVIE = 'movie'
export const PATH_NAME_GLOBAL = 'global'

// category
export const ROUTE_NAME_MAIN_CATEGORY = 'MainCategory'
export const ROUTE_NAME_SUB_CATEGORY = 'SubCategory'

// otherInTheMainLayout
export const PATH_NAME_MOVIE_18 = 'movie_18'
export const PATH_NAME_SCHEDULE = 'schedule'

// baseball
export const PATH_NAME_BASEBALL = 'baseball'
export const PATH_NAME_BASEBALL_SCHEDULE = 'baseball_schedule'
export const PATH_NAME_BASEBALL_HIGHLIGHT = 'baseball_highlight'
export const PATH_NAME_BASEBALL_RESULT = 'baseball_result'
export const PATH_NAME_PLAYER_BASEBALL_LIVE = 'player_baseball_live'
export const PATH_NAME_PLAYER_BASEBALL_HIGHLIGHT = 'player_baseball_highlight'

// my
export const PATH_NAME_MY = 'my'
export const PATH_NAME_USE_LIST_VOD_HISTORY = 'use_list_vod_history'
export const PATH_NAME_USE_LIST_MOVIE_HISTORY = 'use_list_movie_history'
export const PATH_NAME_USE_LIST_DOWNLOAD_HISTORY = 'use_list_download'
export const PATH_NAME_LIKE_CHANNEL = 'like_channel'
export const PATH_NAME_LIKE_THEME = 'like_theme'
export const PATH_NAME_LIKE_PROGRAM = 'like_program'
export const PATH_NAME_LIKE_MOVIE = 'like_movie'
export const PATH_NAME_RESERVE_WATCH = 'reserve_watch'
export const PATH_NAME_VOUCHER_LIST_SINGULAR = 'voucher_list_singular'
export const PATH_NAME_VOUCHER_LIST_PACKAGE = 'voucher_list_package'
export const PATH_NAME_SUBSCRIPTION_TICKET = 'subscription_ticket'
export const PATH_NAME_COIN = 'coin'
export const PATH_NAME_COUPON = 'coupon'
export const PATH_NAME_USER_QNA_VIEW = 'user_qna_view'

// list
export const PATH_NAME_LIST = 'list'
export const PATH_NAME_INSTANT_LIST = 'InstantList'
export const PATH_NAME_BAND_VIEW_GNB_CODE = 'BandViewGnbCode'
export const PATH_NAME_BAND_VIEW_API = 'BandViewApi'

// customer
export const PATH_NAME_NOTICE_LIST = 'notice_list'
export const PATH_NAME_NOTICE_VIEW = 'notice_view'
export const PATH_NAME_FAQ = 'faq'
export const PATH_NAME_AGREEMENT = 'agreement'
export const PATH_NAME_EVENT_LIST = 'event_list'
export const PATH_NAME_EVENT_VIEW = 'event_view'
export const PATH_NAME_EVENT_BOARD_LIST = 'event_board_list'
export const PATH_NAME_EVENT_BOARD_VIEW = 'event_board_view'
export const PATH_NAME_USER_QNA = 'user_qna'
export const PATH_NAME_BUSINESS = 'business'
export const PATH_NAME_RECRUIT = 'recruit'
export const PATH_NAME_FINANCIAL_STATEMENTS = 'financial_statements'
export const PATH_NAME_COMPANY = 'company'
export const PATH_NAME_SERVICE = 'service'
export const PATH_NAME_PRIVACY_AGREEMENT = 'privacy_agreement'

// voucher
export const PATH_NAME_VOUCHER_INDEX = 'voucher_index'
export const PATH_NAME_VOUCHER_WAVVEON = 'wavveon'
export const PATH_NAME_VOUCHER_PROMOTION = 'voucher_promotion'
export const PATH_NAME_COIN_CHARGE_FOR_DCB = 'coin_charge_for_dcb'

// player
export const PATH_NAME_PLAYER_VOD = 'player_vod'
export const PATH_NAME_PLAYER_LIVE = 'player_live'
export const PATH_NAME_PLAYER_MOVIE = 'player_movie'
export const PATH_NAME_PLAYER_STREAM = 'player_stream'

// account
export const PATH_NAME_LOGIN = 'login'
export const PATH_NAME_ADULT_CONTENTS = 'adult_contents'
export const PATH_NAME_LOGIN_APPLE = 'login_apple'

// search
export const PATH_NAME_CATEGORY_SEARCH = 'categorySearch'
export const PATH_NAME_SEARCH = 'search'
export const PATH_NAME_SEARCH_TAG = 'search_tag'
export const PATH_NAME_SEARCH_TAG_GROUP = 'search_tag_group'

// member
export const PATH_NAME_PROFILE_LIST = 'profile_list'
export const PATH_NAME_PROFILE_EDIT = 'profile_edit'
export const PATH_NAME_PROFILE_CHANGE = 'profile_change'
export const PATH_NAME_MEMBER_LOGIN = 'member_login'

// adult
export const PATH_NAME_ADULT = 'adult'
export const PATH_NAME_ADULT_DOWNLOAD = 'adult_download'
export const PATH_NAME_ADULT_INFORMATION_POPUP = 'adult_information_popup'
export const PATH_NAME_ADULT_DOWNLOAD_INFORMATION_POPUP =
  'adult_download_information_popup'
export const PATH_NAME_PINCODE_CHECK = 'pincode_check'
export const PATH_NAME_DOWNLOAD_PINCODE_CHECK = 'download_pincode_check'
export const PATH_NAME_PINCODE_COMPLETE = 'pincode_complete'
export const PATH_NAME_DOWNLOAD_PINCODE_COMPLETE = 'download_pincode_complete'

// other
export const PATH_NAME_WAVVEON_INTRO = 'wavveon_intro'
export const PATH_NAME_POPUP_VOUCHER = 'popup_voucher'
export const PATH_NAME_REVOCATION_DEFENSE = 'revocation_defense'
export const PATH_NAME_T_LOGIN_CALLBACK = 'tlogincallback'
export const PATH_NAME_CONSTRUCTION = 'construction'
export const PATH_NAME_WAITING_SERVICE = 'waitingService'
export const PATH_NAME_WAVVIE_POPUP = 'wavvie_popup'
export const PATH_NAME_EVENT_EMERGENCY = 'event_emergency'
export const PATH_NAME_PLAYER_TEST = 'player_test'

// redirct
export const PATH_NAME_HOME_REDIRECT = 'home_redirect'
export const PATH_NAME_THEME_MOVIE = 'theme-movie'
export const PATH_NAME_THEME_VOD = 'theme-vod'
export const PATH_NAME_CUSTOMER_AGREEMENT_REDIRECT =
  'customer_agreement_redirect'
export const PATH_NAME_EVENT_LIST_REDIRECT = 'event_list_redirect'
export const PATH_NAME_EVENT_DETAIL_REDIRECT = 'event_detail_redirect'
export const PATH_NAME_EVENT_BOARD_LIST_REDIRECT = 'event_board_list_redirect'
export const PATH_NAME_EVENT_BOARD_VIEW_REDIRECT = 'event_board_view_redirect'
export const PATH_NAME_LOGIN_REDIRECT = 'login_redirect'
export const PATH_NAME_MYPOOQ_INDEX_REDIRECT = 'mypooq_index_redirect'
export const PATH_NAME_MYPOOQ_REDIRECT = 'mypooq_rediect'
export const PATH_NAME_COVER_REDIRECT = 'cover_page'
export const PATH_NAME_SEARCH_REDIRECT = 'search_redirect'
export const PATH_NAME_SIGNUP_REDIRECT = 'path_name_signup_redirect'

// promotion
export const PATH_NAME_PROMOTION_USER = 'promotion_user'

// notFound
export const PATH_NAME_ERROR = 'error'

// terms
export const PATH_NAME_SIGN_UP_TERMS = 'sign_up_terms'

export const HOME_API_ROUTE_LIST = [
  PATH_NAME_HOME,
  ROUTE_NAME_MAIN_CATEGORY,
  ROUTE_NAME_SUB_CATEGORY,
]
